export default function returnDate(date: string): string {
  const month = date.split("-")[1];
  const year = date.split("-")[0];
  const day = date.split("-")[2].split("T");

  return `${year}-${month}-${day[0]}`;
}
